module.exports = __webpack_public_path__ + "media/images/easy-steps-2-edcbc573259f78db5618060834d87446.jpeg";